<template>
  <transition name="update-banner">
    <div class="update-banner" v-if="state.available && !state.dismissed" role="status" aria-live="polite">
      <span class="update-icon" aria-hidden="true"><tkd-icon name="refresh"/></span>
      <div class="update-text">
        <b>Доступна нова версія системи</b>
        <span>Оновіть сторінку, щоб працювати з актуальною версією. Вхід і чернетки збережуться.</span>
      </div>
      <div class="update-actions">
        <button type="button" class="update-btn primary" @click="reload()" :disabled="reloading">
          {{ reloading ? 'Оновлення…' : 'Оновити' }}
        </button>
        <button type="button" class="update-btn" @click="state.dismissed = true">Пізніше</button>
      </div>
    </div>
  </transition>
</template>

<script>
  import 'src/assets/css/tkd-theme.css';
  import { updateState, hardReload } from 'src/utils/appUpdate';

  export default {
    name: 'AppUpdateBanner',
    data () {
      return {
        state: updateState,
        reloading: false,
      }
    },
    methods: {
      reload () {
        this.reloading = true;
        hardReload();
      },
    },
  }
</script>

<style scoped>
  .update-banner {
    position: fixed;
    left: 50%;
    bottom: 20px;
    z-index: 10001;
    display: flex;
    align-items: center;
    gap: 14px;
    width: calc(100% - 32px);
    max-width: 640px;
    padding: 14px 16px;
    border-radius: var(--tkd-radius-lg);
    background: var(--tkd-navy);
    box-shadow: 0 16px 40px rgba(6, 16, 38, 0.35);
    font-family: var(--tkd-font);
    color: #fff;
    transform: translateX(-50%);
  }

  .update-icon { flex-shrink: 0; font-size: 22px; }

  .update-text { flex: 1; min-width: 0; line-height: 1.35; }
  .update-text b { display: block; font-size: 15px; }
  .update-text span { font-size: 13px; color: rgba(255, 255, 255, 0.7); }

  .update-actions { display: flex; gap: 8px; flex-shrink: 0; }

  .update-btn {
    height: 38px;
    margin: 0;
    padding: 0 14px;
    border: 1.5px solid rgba(255, 255, 255, 0.3);
    border-radius: var(--tkd-radius);
    background: transparent;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    cursor: pointer;
  }

  .update-btn:hover { background: rgba(255, 255, 255, 0.1); }
  .update-btn.primary { border-color: #fff; background: #fff; color: var(--tkd-navy); }
  .update-btn.primary:hover { background: rgba(255, 255, 255, 0.9); }
  .update-btn:disabled { opacity: 0.7; cursor: wait; }
  .update-btn:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }

  .update-banner-enter-active, .update-banner-leave-active { transition: opacity 0.2s, transform 0.2s; }
  .update-banner-enter, .update-banner-leave-to { opacity: 0; transform: translate(-50%, 12px); }

  @media (max-width: 480px) {
    .update-banner { flex-wrap: wrap; bottom: 12px; }
    .update-actions { width: 100%; }
    .update-btn { flex: 1; }
  }

  @media (prefers-reduced-motion: reduce) {
    .update-banner-enter-active, .update-banner-leave-active { transition: none; }
  }
</style>
